
import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
} from "recharts";
import { $crud } from "../../utils/CrudFactory";

const CustomerBarChart = () => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const res = await $crud.retrieve("/admin/customer-orders-map"); 
        const apiData = res.data || []; 

        // Transform API response into recharts format
        const formattedData = apiData.map((day, i) => ({
          name: day.day, 
         value: day.count,
          fill: i % 2 === 0 
            ? "rgba(104, 60, 140, 0.35)" 
            : "rgba(104, 60, 140, 1)",
        }));

        setChartData(formattedData);
      } catch (err) {
        console.error("Error fetching customer orders map:", err);
      }
    };

    fetchChartData();
  }, []);

  return (
    <BarChart
      width={600}
      height={170}
      data={chartData}
      margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
    >
      <XAxis
        dataKey="name"
        axisLine={false}
        tickLine={false}
        tick={{
          fontSize: "11px",
          fontWeight: 400,
          fill: "rgba(103, 60, 142, 1)",
        }}
      />
      <YAxis
        axisLine={false}
        tickLine={false}
        tick={{
          fontSize: "11px",
          fontWeight: 400,
          fill: "rgba(103, 60, 142, 1)",
        }}
        ticks={[0, 20, 40, 60, 80]}
      />
      <Bar dataKey="value" barSize={10}>
        {chartData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
      </Bar>
    </BarChart>
  );
};

export default CustomerBarChart;
